module.exports = __webpack_public_path__ + "img/smart-construction-section-2-phone2.20df31d4.png";